<template>
<portal to="PortalGraphTypeList">
    <b-button-group class="d-flex btn-gray-light rounded-pill border border-gray">
        <b-button v-b-tooltip.hover @click="changeTypeGraph('BarLine')" :title="$t('BarLineChart')"
                  :pressed="true"
                  pill variant="outline-white"
                  :class="[ 'p-1 graphMode border-0', {'text-black' : false}]"> <!-- Graphique Lignes et barres -->
            <b-iconstack> 
                <b-icon icon="text-right" rotate="90" shift-h="0.5" scale="0.75" shift-v="-1"></b-icon>
                <b-icon icon="slash" rotate="135" shift-h="-5" scale="0.75" shift-v="-2"></b-icon>
                <b-icon icon="slash" shift-v="5" shift-h="-2" scale="0.5"></b-icon>
                <b-icon icon="slash" shift-v="5" rotate="90" scale="0.5"></b-icon>
                <b-icon icon="slash" shift-v="5" shift-h="3" scale="0.5"></b-icon>
                <b-icon icon="slash" shift-v="4" shift-h="-5" rotate="90" scale="0.5"></b-icon>
            </b-iconstack>
        </b-button>
    </b-button-group>
</portal>
</template>

<script lang="ts">
import {PropSync, Vue} from "vue-property-decorator";
import Dictionary from "@/types/Dictionary";
import Component from "vue-class-component";

@Component({})
export default class ChartWorkGoal extends Vue {
    /** Données synchronisées pour le composant appelant */
    @PropSync('Configs', {default: () => [{}]})
    public configs!: Dictionary<any>;

    /** Option du graphique Apache EChart */
    @PropSync('Result', {
        default: () => {
            option: {};
            graphTheme: "default-theme";
            menus: [];
        }
    })
    public results!: any;

    @PropSync('Messages', {default: () => []})
    public messages!: string[];
}
</script>

<style scoped>

/** Style appliqué pour les boutons de selection du mode de période (Simple <=> Avancée) */
:deep(.btn.active.graphMode) {
    background-color: var(--white) !important;
    color: var(--secondary) !important;
}
</style>